// import { getStore, setStore } from '@/util/store';
// import languageConfig from '@/config/language';

const base = {
    state: {
      answer:'', //答案
      disabled:false
    },
    mutations: {
        SET_ANSWER(state,answer){
            state.answer = answer
        }
    },

    actions: {},
};

export default base;



// WEBPACK FOOTER //
// ./src/store/modules/base.js